module.exports = __webpack_public_path__ + "img/planeOld.4ad50cf6.png";